"use strict";
// AUTO-GENERATED from contracts/morfi-cp-swap/programs/cp-swap/src/error.rs
// via scripts/generate-error-package.ts.
// Do NOT edit by hand — run `pnpm --filter @morfi/errors run generate` after a contract error change.
Object.defineProperty(exports, "__esModule", { value: true });
exports.CP_SWAP_ERROR_BY_CODE = exports.CP_SWAP_ERRORS = void 0;
exports.parseCpSwapError = parseCpSwapError;
exports.isCpSwapError = isCpSwapError;
exports.CP_SWAP_ERRORS = {
    NotApproved: { code: 6000, name: 'NotApproved', msg: 'Not approved', module: 'swap' },
    InvalidOwner: {
        code: 6001,
        name: 'InvalidOwner',
        msg: 'Input account owner is not the program address',
        module: 'swap',
    },
    EmptySupply: {
        code: 6002,
        name: 'EmptySupply',
        msg: 'Input token account empty',
        module: 'swap',
    },
    InvalidInput: { code: 6003, name: 'InvalidInput', msg: 'InvalidInput', module: 'swap' },
    IncorrectLpMint: {
        code: 6004,
        name: 'IncorrectLpMint',
        msg: 'Address of the provided lp token mint is incorrect',
        module: 'swap',
    },
    ExceededSlippage: {
        code: 6005,
        name: 'ExceededSlippage',
        msg: 'Exceeds desired slippage limit',
        module: 'swap',
    },
    ZeroTradingTokens: {
        code: 6006,
        name: 'ZeroTradingTokens',
        msg: 'Given pool token amount results in zero trading tokens',
        module: 'swap',
    },
    NotSupportMint: {
        code: 6007,
        name: 'NotSupportMint',
        msg: 'Not support token_2022 mint extension',
        module: 'swap',
    },
    InvalidVault: { code: 6008, name: 'InvalidVault', msg: 'invaild vault', module: 'swap' },
    InitLpAmountTooLess: {
        code: 6009,
        name: 'InitLpAmountTooLess',
        msg: 'Init lp amount is too less(Because 100 amount lp will be locked)',
        module: 'swap',
    },
    TransferFeeCalculateNotMatch: {
        code: 6010,
        name: 'TransferFeeCalculateNotMatch',
        msg: 'TransferFee calculate not match',
        module: 'swap',
    },
    MathOverflow: { code: 6011, name: 'MathOverflow', msg: 'Math overflow', module: 'swap' },
    InsufficientVault: {
        code: 6012,
        name: 'InsufficientVault',
        msg: 'Insufficient vault',
        module: 'swap',
    },
    InvalidFeeModel: {
        code: 6013,
        name: 'InvalidFeeModel',
        msg: 'Invalid fee model',
        module: 'swap',
    },
    NoFeeCollect: { code: 6014, name: 'NoFeeCollect', msg: 'Fee is zero', module: 'swap' },
    InvalidMarketsConfig: {
        code: 6015,
        name: 'InvalidMarketsConfig',
        msg: 'Invalid Markets AMM config',
        module: 'swap',
    },
    MarketsConfigImmutable: {
        code: 6016,
        name: 'MarketsConfigImmutable',
        msg: 'Markets AMM config is immutable',
        module: 'swap',
    },
    InvalidMarketsMarket: {
        code: 6017,
        name: 'InvalidMarketsMarket',
        msg: 'Invalid Markets market account',
        module: 'swap',
    },
    InvalidMarketsOutcomeMint: {
        code: 6018,
        name: 'InvalidMarketsOutcomeMint',
        msg: 'Invalid Markets outcome mint',
        module: 'swap',
    },
    InvalidMarketsOutcomeMintAuthority: {
        code: 6019,
        name: 'InvalidMarketsOutcomeMintAuthority',
        msg: 'Markets outcome mint authority must be revoked',
        module: 'swap',
    },
    InvalidMarketsSourceVault: {
        code: 6020,
        name: 'InvalidMarketsSourceVault',
        msg: 'Invalid Markets source vault',
        module: 'swap',
    },
    InvalidMarketsAlias: {
        code: 6021,
        name: 'InvalidMarketsAlias',
        msg: 'Invalid Markets graduation account alias',
        module: 'swap',
    },
    InvalidMarketsLiquidity: {
        code: 6022,
        name: 'InvalidMarketsLiquidity',
        msg: 'Invalid Markets graduation liquidity',
        module: 'swap',
    },
    MarketsPoolAlreadyInitialized: {
        code: 6023,
        name: 'MarketsPoolAlreadyInitialized',
        msg: 'Markets pool is already initialized or squatted',
        module: 'swap',
    },
    MarketsPoolImmutable: {
        code: 6024,
        name: 'MarketsPoolImmutable',
        msg: 'Markets protected pool is immutable',
        module: 'swap',
    },
};
exports.CP_SWAP_ERROR_BY_CODE = new Map(Object.values(exports.CP_SWAP_ERRORS).map((e) => [e.code, e]));
function parseCpSwapError(code) {
    return exports.CP_SWAP_ERROR_BY_CODE.get(code);
}
function isCpSwapError(code) {
    return exports.CP_SWAP_ERROR_BY_CODE.has(code);
}
